import { createBrowserHistory } from "history";
export const browserHistory = createBrowserHistory({});
//# sourceMappingURL=History.js.map